import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";

// Добавляем ссылки на изображения флагов
const languages = [
  { code: "en", name: "English", flag: "https://flagcdn.com/us.svg" },
  { code: "ru", name: "Русский", flag: "https://flagcdn.com/ru.svg" },
  { code: "tr", name: "Türkçe", flag: "https://flagcdn.com/tr.svg" },
  { code: "de", name: "Deutsch", flag: "https://flagcdn.com/de.svg" },
];

interface Props {
  OnChanged: () => void;
}

const LanguagePicker: React.FC<Props> = ({ OnChanged }: Props) => {
  const { i18n } = useTranslation();

  // Функция для определения языка пользователя
  const detectUserLanguage = () => {
    const browserLang = navigator.language.split("-")[0]; // 'en-US' -> 'en'
    const isLanguageSupported = languages.some(
      (lang) => lang.code === browserLang
    );
    return isLanguageSupported ? browserLang : "en";
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("userLanguage");
    if (
      savedLanguage &&
      languages.some((lang) => lang.code === savedLanguage)
    ) {
      i18n.changeLanguage(savedLanguage);
    } else {
      const detectedLang = detectUserLanguage();
      i18n.changeLanguage(detectedLang);
    }
  }, [i18n]);

  const changeLanguage = (lng: string) => {
    localStorage.setItem("userLanguage", lng);
    i18n.changeLanguage(lng);
    OnChanged();
  };

  return (
    <div className="flex flex-row dropdown">
      <Dropdown>
        <Dropdown.Toggle
          id="dropdown-language-picker"
          className="btn btn-secondary flex items-center gap-2 w-full"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div className="flex items-center gap-2 flex-grow">
            <img
              src={
                languages.find((lang) => lang.code === i18n.language)?.flag ||
                "https://flagcdn.com/us.svg"
              }
              alt="flag"
              className="w-5"
            />
            <span>
              {languages.find((lang) => lang.code === i18n.language)?.name ||
                "Select Language"}
            </span>
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {languages.map((language) => (
            <Dropdown.Item
              key={language.code}
              onClick={() => changeLanguage(language.code)}
              active={i18n.language === language.code}
              className="flex flex-row items-center gap-2"
            >
              <div className=" flex flex-row gap-2">
                <img src={language.flag} alt={language.name} className="w-5" />
                <span>{language.name}</span>
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LanguagePicker;
